import { notification } from 'antd'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'

import { customAxios as axios, getToken } from '../../../request'
import {
  getArticleActivitiesUrl,
  getFeedbacksUrl,
  getUsersUrl, getUserUrl, editFeedbackUrl,
  updateAdminUserUrl, updateUserUrl, deleteAdminUserUrl, allUserExportUrl,
  changePasswordUrl
} from '../apis'
import { removeKeywordUrl } from '../../keyword/api/api'
import { onlineSubmissionExportUrl } from '../../onlineSubmission/apis'
export const getAllUsersFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...getToken()
  }
  let { data } = await axios.get(getUsersUrl(), config)
  dispatch(hidePageLoad())

  return data
}

export const updateAdminUser = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateAdminUserUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}
export const getArticleActivities = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...getToken()
  }
  let { data } = await axios.get(getArticleActivitiesUrl(), config)
  dispatch(hidePageLoad())

    return data
}
export const getFeedBacks = filters => async dispatch => {
    dispatch(showPageLoad())
    let config = {
        params: {...filters},
        ...getToken()
    }
    let {data} = await axios.get(getFeedbacksUrl(), config)
    dispatch(hidePageLoad())

    return data
}
export const getUserFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(getUserUrl(), valData, getToken())
    dispatch(hidePageLoad())
    if (data.error) {
        notification.error({
            message: data.message || 'Error'
        })
    }

    return data
}

export const updateUserFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(updateUserUrl(), valData, getToken())
    dispatch(hidePageLoad())
    if (data.error) {
        notification.error({
            message: data.message || 'Error'
        })
    } else {
        notification.success({
            message: data.message || 'Success'
        })
    }

    return data
}
export const updateFeedback = ( valData) => async (dispatch) => {
  dispatch(showPageLoad())

  let { data } = await axios.put(editFeedbackUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }else{
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}
export const deleteAdminUserFxn = (record) => async (dispatch) => {
  dispatch(showPageLoad())
  // console.log(record)
  let { data } = await axios.delete(deleteAdminUserUrl(record._id), getToken());
  dispatch(hidePageLoad())
  return data;
}
    export const allUserExportFxn = valData => async dispatch => {
  dispatch(showPageLoad())

    console.log(valData, "valDatavalDatavalData")

    let {data} = await axios.post(allUserExportUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const changePassword = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.put(changePasswordUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Email send Successfully'
    })
  }
  return data
}

